import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
  Message,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import SearchProjectUnit from '../../components/SearchProjectUnit';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class BookingSwapUnit extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    projectUnitClear: PropTypes.func.isRequired,
    projectUnitSelect: PropTypes.func.isRequired,
    projectUnitselectedValue: PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    projectID: PropTypes.string.isRequired,
    hasAccess: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    manualSwap: PropTypes.bool,
  }
  static defaultProps = {
    manualSwap: false,
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  handleProjectUnitClear = () => {
    if (this.props.projectUnitClear) {
      this.props.projectUnitClear();
    }
  }
  handleProjectUnitSelect = (value) => {
    if (this.props.projectUnitSelect) {
      this.props.projectUnitSelect(value);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        size="small"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeOnDimmerClick={false}
        closeOnEscape={false}
      >
        <Header icon={this.props.manualSwap ? 'refresh' : 'warning sign'} content={t(this.props.manualSwap ? 'Change Unit' : 'Selected unit has just been reserved. Kindly select another unit.')} />
        <Modal.Content>
          <Modal.Description>
            { this.props.error &&
              <Message>
                <Message.Header>
                  {t('Unit selected is unavailable for reservation')}.
                </Message.Header>
              </Message>
            }
            <SearchProjectUnit
              onClear={this.handleProjectUnitClear}
              onSelect={this.handleProjectUnitSelect}
              selectedValue={this.props.projectUnitselectedValue}
              projectID={this.props.projectID}
              hasAccess={this.props.hasAccess}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          { this.props.manualSwap ?
            <Button onClick={this.handleOnClose} content={t('Cancel', { ns: TRANSLATION_FILES.translation })} /> :
            <Button onClick={this.handleOnClose} icon="arrow left" content={t('Back To Units List')} />
          }
          <Button positive onClick={this.handleOnComfirm} disabled={this.props.projectUnitselectedValue.key === ''} icon="checkmark" content={t('Change Unit')} />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(BookingSwapUnit);



// WEBPACK FOOTER //
// ./src/containers/modals/BookingSwapUnit.jsx